import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkGfm from "remark-gfm";

const customSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames ?? []), "button", "style", "iframe"],
  attributes: {
    ...defaultSchema.attributes,
    "*": ["class", "style", "id"],
    a: ["href", "target", "rel"],
    iframe: ["src", "width", "height", "allow", "frameborder"],
  },
  protocols: {
    ...defaultSchema.protocols,
    src: ["https"],
    href: ["https", "mailto"],
  },
};

export const Markdown: React.FC<{ children: string; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <ReactMarkdown
      className={className}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, [rehypeSanitize, customSchema]]}
    >
      {children}
    </ReactMarkdown>
  );
};
